<app-company-base (companyAvailable)="companyAvailableHandler($event)"
    [useContainer]="false">
    
    <div>
        <div>
            <h1 class="mat-headline-1">{{title}}</h1>
            @if(description){
                <p>{{description}}</p>
            }
            
        </div>
        @if(enableDateFilter){
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 10px;" >
                <div>
                    Showing data from {{dateRange?.startDate | date}} to {{dateRange?.endDate | date}}
                    <button mat-icon-button color="accent" (click)="showSelect = !showSelect">
                        <app-icon-core [icon]="'edit'" *ngIf="!showSelect"></app-icon-core>
                        <app-icon-core [icon]="'close'" *ngIf="showSelect"></app-icon-core>
                    </button>
                </div>
                
            </div>
        }
        
        
        @if(showSelect){
            <app-date-range-selector 
                [region]="region"
                [basicMode]="dateFilterBasicMode"
                (selectedDateRange)="selectedDateRangeHandler($event)"
                >
            </app-date-range-selector>
        }

        @if(showTabBar){
            <div style="margin-bottom: 10px;" fxLayout="row" fxLayout.lt-lg="column"  fxLayoutAlign="space-between center" fxLayoutAlign.lt-lg="start start" fxLayoutGap="4px">
                @if(useDropdownMode){
                    @if(tabItems.length === 0){
                        <p>{{noTabsText}}</p>
                    }
                    @else{
                        <div fxFlex="40">
                            <mat-form-field class="mat-field-width mat-form-field-override">
                                <mat-select [(ngModel)]="updatedSelectedItem"
                                    (selectionChange)="updateTab()">
                                    @for(item of tabItems; track item){
                                        <mat-option [value]="item">{{item.value}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    }
                    
                }
                @else{
                    @if(tabItems.length === 0){
                        <p>{{noTabsText}}</p>
                    }
                    @else{
                        <nav fxFlex="40"
                                mat-tab-nav-bar 
                                mat-stretch-tabs="false"
                                [tabPanel]="tabPanel">
                            @for(item of tabItems; track item){
                                <a mat-tab-link [routerLink]="['..',item.key]"
                                    [active]="item.key === selectedItem?.key"
                                    >
                                    <h2>{{item.value}}</h2>
                                </a>
                            }
                        </nav>
                    }
                }
                
                <app-common-group-header fxFlex style="max-width: 870px;"
                            *ngIf="showCommonHeader"
                            [pageSize]="pageSize"
                            [itemCount]="itemCount"
                            [optionalDisplayColumns]="optionalDisplayColumns"
                            [name]="selectedItem?.value"
                            [currentPageIndex]="currentPageIndex"
                            [pageSizeOptions]="pageSizeOptions"
                            [selectedIds]="selectedIds"
                            [enableSearch]="enableSearch"
                            [enableSettings]="enableSettings"
                            [enableBatch]="enableBatch"
                            [enableTitle]="false"
                            [mode]="batchMode"

                            (updatePageSize)="updatePageSizeHandler($event)"
                            (searchExecute)="searchHandler($event)"
                            (searchClear)="clearSearchHandler()"
                            (updatePage)="updatePageHandler($event)"
                            (setupDisplayColumns)="setupDisplayColumnsHandler()"
                            (batchEditCommand)="batchEditCommandHandler($event)"
                        >
                </app-common-group-header>
            </div>
        }
        
        <mat-tab-nav-panel #tabPanel>
            <ng-content></ng-content>
        </mat-tab-nav-panel>
        
        
    </div>

</app-company-base>